export default __webpack_public_path__ + "static/media/BlueEllipse.14055e00.svg";